export enum WorkerStatusEnum {
  Created = 1,
  ActivationInProgress = 2,
  Activated = 3,
  NotCreated = 4
}
